import releases from './releases/routes'
import tickets from './tickets/routes'
// import home from './home/routes'
import notfound from './404/routes'
import login from './login/routes'
import users from './users/routes'
import guide from './guide/routes'
import tasks from './tasks/routes'
import meetings from './meetings/routes'
import applications from './apps/routes'
import steps from './steps/routes'

export default [...notfound, ...releases, ...tickets, ...login, ...users, ...guide, ...tasks, ...meetings, ...applications, ...steps]